import styled from "@emotion/styled";
import { Box, Checkbox, ListItemText } from "@mui/material";

export const FilterRowItem = styled(Box)<{isDisabled?: boolean}>(({ isDisabled }) => ({
  fontFamily: "CircularStd,Helvetica,Arial,sans-serif",
  fontWeight: 400,
  fontSize: "0.875rem",
  lineHeight: 1.43,
  verticalAlign: "inherit",
  padding: "16px",
  opacity: isDisabled ? 0.4 : 1,
  pointerEvents: isDisabled ? 'none' : 'all',
  userSelect: isDisabled ? 'none' : 'all',
}));

export const MultiSelectLi = styled.li`
  padding: 6px;
  align-items: 'flex-start';
`;

export const MultiSelectCheckbox = styled(Checkbox)`
  padding: '0 9px';
`;

export const MultiSelectText = styled(ListItemText)`
  margin: 0;
  word-break: 'break-word'
`;